module.exports = __webpack_public_path__ + "img/fuwuJiaoXue1.2564e72.png";